import { getItemInLocalStorage, setItemInLocalStorage, sessionKeys} from '../helpers/StorageHelper'

const initialState = {
    language: 'en'
};

const app = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_MS_CONTEXT':
            const stateToModify = { ...state }
            stateToModify.language = action.payload.context ? action.payload.context.locale : stateToModify.language;
            setItemInLocalStorage(sessionKeys.Language, stateToModify.language)
            return Object.assign({}, stateToModify, { context: action.payload.context });
        case 'GET_LANGUAGE':
            const language = action.payload.language
            setItemInLocalStorage(sessionKeys.Language, language)
            return Object.assign({}, state, { language: language });
        default:
            return state
    }
}

export default app